import React from "react";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import "jsvectormap/dist/jsvectormap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-modal-video/css/modal-video.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppKitProvider } from "./AppKitProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <AppKitProvider>
      <App />
      <ToastContainer position="top-right" />
    </AppKitProvider>
  </>
);
